const Expense = {

    // PAGE HEADER
    "expense": "Expense",
    "expenses": "Expenses",
    "load_error": "Something went wrong. Unable to load details.",
    "no_notes": "No notes provided.",
    "view_invoice": "View",

    // FIELDS
    "premise": "Premise",
    "expense_date": "Expense Date",
    "user_type": "User Type",
    "staff": "Staff",
    "vendor": "Vendor",
    "vendor_details": "Vendor Details",
    "vendor_code": "Vendor Code",
    "contact_person": "Contact Person",
    "mobile_number": "Mobile Number",
    "email": "Email",
    "profile": "Profile",
    "expense_type": "Expense Type",
    "amount": "Amount",
    "invoice_bill": "Invoice/Bill",
    "notes": "Notes",
    "search": "Search",
    "date_from": "Date From",
    "date_to": "Date To",
    "created_at": "Created Date",
    "expense_amount_details": "Expense Details",
    "billing_total_amount": "Total Amount",
    "billing_settle_amount": "Settle Amount",
    "billing_paid_amount": "Paid Amount",
    "billing_due_amount": "Due Amount",
    "add_payment": "Add Payment",
    "payment_type": "Payment Type",
    "partial_payment": "Partial Payment",
    "full_payment": "Full Payment",
    "mode_of_payment": "Mode of Payment",
    "description": "Description",
    "success_payment": "Payment added successfully.",
    "payment_mode_cash": "Cash",
    "payment_mode_cheque": "Cheque",
    "payment_mode_online": "Online",
    "payment_summary": "Payment Summary",
    "no_payments": "No payments recorded.",
    "payment_by": "Payment By",
    "table_payment_date": "PAYMENT DATE",
    "table_payment_mode": "MODE",
    "table_payment_type": "TYPE",
    "table_payment_amount": "AMOUNT",
    "table_settle_amount": "SETTLE AMOUNT",
    "table_payment_description": "DESCRIPTION",

    // TABLE HEADERS
    "table_expense_date": "EXPENSE DATE",
    "table_vendor": "VENDOR/STAFF",
    "table_expense_type": "EXPENSE TYPE",
    "table_amount": "AMOUNT",
    "table_created_at": "CREATED DATE",
    "table_status": "STATUS",

    // ERROR
    "error_premise": "Select Premise",
    "error_expense_date": "Select Expense Date",
    "error_user_type": "Select User Type",
    "error_staff": "Select Staff",
    "error_vendor": "Select Vendor",
    "error_expense_type": "Select Expense Type",
    "error_amount": "Enter Amount",
    "error_amount_positive": "Amount must be greater than zero",
    "error_amount_exceeds_due": "Amount cannot be greater than the due amount",
    "error_payment_type": "Select Payment Type",
    "error_payment_mode": "Select Mode of Payment",
    "error_invoice": "Upload Invoice/Bill",
    "error_file_type": "Only PDF, DOC, DOCX, and image files are allowed",
    "error_file_size": "File size must be less than 5 MB",
};

export default Expense;